import React from "react";
import BgForm from "../../images/bg-form.png";
import IconFlightTrip from "../../images/ic_flighttrip.svg";
import { calculateTimeDifference } from "../../helpers/utils";
import { Button, Tag, notification } from "antd";
import moment from "moment";
import _ from "lodash";
import { formatDateNoTime, formatTime } from "../../helpers/formatDate";
import $axios from "../../services/axios";

const Step4 = ({
  onChangeStep,
  bookingInfo,
  chooseFlight,
  airports,
  setLoading,
}) => {
  const baggage = _.sum([
    bookingInfo.totalListPrice.baggage,
    bookingInfo.totalListPrice.baggage_out,
  ]);
  const handlePayment = async () => {
    setLoading(true);
    try {
      console.log(bookingInfo, "bookingInfo");
      const res = await $axios.$post("/honghatrip/payment-namabank", {
        OrderCode: bookingInfo.orderId,
      });
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.NativeJavascriptInterface
      ) {
        window.webkit.messageHandlers.NativeJavascriptInterface.postMessage({
          orderCode: res.data.data.transactionid,
        });
      } else {
        console.error(
          "NativeJavascriptInterface không tồn tại hoặc không được hỗ trợ."
        );
      }
    } catch (error) {
      notification.error({
        message: "Thông báo",
        description: error?.response?.data?.message || error?.response?.data?.err || "Không thể khởi tạo giao dịch thanh toán !",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#F6F6F6] mb-4">
      <div className="bg-primary h-[300px] relative">
        <section className="step-indicator">
          <div className="step step1 actived">
            <div className="step-icon" onClick={() => onChangeStep(1)}>
              1
            </div>
            <p>Tìm kiếm</p>
          </div>
          <div className="indicator-line active"></div>
          <div className="step step2 actived">
            <div className="step-icon">2</div>
            <p>Thông tin</p>
          </div>
          <div className="indicator-line active"></div>
          <div className="step step3 actived">
            <div className="step-icon">3</div>
            <p>Xác nhận</p>
          </div>
          <div className="indicator-line active"></div>
          <div className="step step4 active">
            <div className="step-icon">4</div>
            <p>Thanh Toán</p>
          </div>
        </section>
        <img src={BgForm} alt="" className="w-full object-cover mx-auto" />
        <div className="flex w-full absolute top-[135px] left-1/2 transform -translate-x-1/2 justify-center gap-8">
          <div className="flex flex-col gap-1">
            <div className="text-white font-semibold text-[18px]">
              {chooseFlight?.[0]?.options?.[0]?.flights?.[0]?.startpoint}
            </div>
            <div className="text-white font-medium text-[11px]">
              {
                airports?.find(
                  (item) =>
                    item.code ===
                    chooseFlight[0].options?.[0]?.flights?.[0]?.startpoint
                )?.namevn
              }{" "}
            </div>
          </div>
          <div className="relative">
            <svg
              width="123"
              height="47"
              viewBox="0 0 123 47"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-primary"
            >
              <path
                d="M0 20L5 22.8868V17.1132L0 20ZM123 20L118 17.1132V22.8868L123 20ZM4.5 20.5H118.5V19.5H4.5V20.5Z"
                fill="white"
              />
              <g filter="url(#filter0_d_212_3608)">
                <circle cx="62.5" cy="19.5" r="19.5" fill="white" />
              </g>
              <path
                d="M71.7335 30.404L73.3261 28.1785L68.063 16.3724L72.4426 10.2524C73.1035 9.32878 72.8628 8.06044 71.9037 7.4128C70.9446 6.76516 69.6368 6.9879 68.9759 7.91147L64.5963 14.0316L51.3703 13.3529L49.7777 15.5784L61.013 19.0389L56.6333 25.159L53.1278 25.2675L51.9333 26.9366L56.7741 28.5549L60.0223 32.3987L61.2167 30.7296L60.1 27.4999L64.4797 21.3798L71.7335 30.404Z"
                fill="currentColor"
              />
              <defs>
                <filter
                  id="filter0_d_212_3608"
                  x="39"
                  y="0"
                  width="47"
                  height="47"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_212_3608"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_212_3608"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div className="flex flex-col gap-1">
            <div className="text-white font-semibold text-[18px]">
              {chooseFlight?.[0]?.options?.[0]?.flights?.[0]?.endpoint}
            </div>
            <div className="text-white font-medium text-[11px]">
              {
                airports?.find(
                  (item) =>
                    item.code ===
                    chooseFlight[0].options?.[0]?.flights?.[0]?.endpoint
                )?.namevn
              }{" "}
            </div>
          </div>
        </div>
        <div className="w-[90%] mx-auto absolute top-[200px] left-1/2 transform -translate-x-1/2 pb-[120px] flex flex-col">
          <div
            style={{
              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
            }}
            className="rounded-[20px] bg-white p-4 mb-[24px] font-medium text-[14px] text-[#0D1634]"
          >
            <div className="text-[20px] mb-3">Thông tin đơn hàng</div>
            <div className="flex items-center mb-2 flex-wrap">
              <span className="whitespace-nowrap">Mã đơn hàng: </span>
              <span className="text-[16px] text-primary pl-2 break-words">
                {bookingInfo?.orderId}
              </span>
            </div>
            {/* <div className="text-[#D72F20] italic font-bold">
              Đơn hàng hết hạn ngày{" "}
              {moment(
                bookingInfo?.transaction?.vmbBookings[0]?.expiryDate
              ).format("DD/MM/YYYY HH:mm")}
            </div> */}
            <hr className="my-3" style={{ borderTopWidth: "2px" }} />
            {/* <div>Hệ thống đã đặt vé thành công.</div>
            <div className=" mb-3">
              Cảm ơn Quý khách đã sử dụng dịch vụ, chúng tôi sẽ liên lạc lại với
              Quý khách hàng sớm nhất.
            </div>
            <div>Mọi thắc mắc xin liên hệ:</div>
            <div>
              <a
                href="tel:1900255585"
                className="font-semibold"
                style={{
                  textDecoration: "none",
                }}
              >
                Hotline: 1900255585
              </a>
            </div>
            <div className="mt-3">
              Trụ sở: Số 10 ngõ 83 phố Bảo Linh, Phường Phúc Tân, Quận Hoàn
              Kiếm, Thành phố Hà Nội, Việt Nam
            </div>
            <div className="my-3">
              Văn phòng Hà Nội: Toà nhà Việt Á, Số 9 Duy Tân, Dịch Vọng Hậu, Cầu
              Giấy, Hà Nội
            </div>
            <div className="my-3">
              Văn phòng Hồ Chí Minh: Số 101 Tân Hóa, Phường 14, Quận 6, Thành
              phố Hồ Chí Minh
            </div>
            <div className="text-[20px] mb-3">Thông tin liên hệ</div>
            <ul className="list-none py-4">
              <li className="flex justify-between mb-2">
                <span className="text-[#808991]">Name</span>
                <span>{bookingInfo?.ContactFullName}</span>
              </li>
              <li className="flex justify-between mb-2">
                <span className="text-[#808991]">Email</span>
                <span>{bookingInfo?.ContactEmail}</span>
              </li>
              <li className="flex justify-between">
                <span className="text-[#808991]">Phone</span>
                <span>{bookingInfo?.ContactPhone}</span>
              </li>
            </ul> */}
            <div className="text-[20px] my-3">Trạng thái thanh toán</div>
            <div className="flex justify-between items-center">
              <span className="text-[#808991]">Trạng thái</span>
              <Tag
                color="#FFBB29"
                className="text-[14px] text-black rounded-[20px] px-2 py-1 mr-0"
              >
                Chưa thanh toán
              </Tag>
            </div>
            <div className="text-[20px] my-3">Thông tin chuyến bay</div>
            <ul className="list-none py-4">
              <li className="flex justify-between mb-2">
                <span className="text-[#808991]">Loại hành trình</span>
                <span>
                  {chooseFlight[0].isdomestic ? "Nội địa" : "Quốc tế"} -{" "}
                  {chooseFlight.length === 1 ? "1 chiều" : "2 chiều"}
                </span>
              </li>
              <li className="flex justify-between mb-2">
                <span className="text-[#808991]">Ngày đi</span>
                <span>
                  {formatDateNoTime(
                    chooseFlight[0]?.options?.[0]?.flights?.[0]?.startdate
                  )}
                </span>
              </li>
              {chooseFlight.length === 2 && (
                <li className="flex justify-between mb-2">
                  <span className="text-[#808991]">Ngày về</span>
                  <span>
                    {formatDateNoTime(
                      chooseFlight[1]?.options?.[0]?.flights?.[0]?.startdate
                    )}
                  </span>
                </li>
              )}

              <li className="flex justify-between">
                <span className="text-[#808991]">Trạng thái</span>
                <Tag className="text-[14px] rounded-[20px] px-2 py-1 mr-0 bg-primary text-white">
                  Đã giữ chỗ
                </Tag>
              </li>
            </ul>
            <hr className="mt-2 mb-4" style={{ borderTopWidth: "2px" }} />
            <div className="mb-3">
              <div className="flex w-full justify-between items-center mb-4">
                <div
                  className="flex flex-col gap-1 items-start"
                  style={{ width: "90px" }}
                >
                  <div className="text-secondary font-semibold text-[20px]">
                    {chooseFlight[0]?.options?.[0]?.flights?.[0]?.startpoint}
                  </div>
                  <div className="text-[#808991] font-medium text-[11px]">
                    {
                      airports?.find(
                        (item) =>
                          item.code ===
                          chooseFlight[0].options?.[0]?.flights?.[0]?.startpoint
                      )?.namevn
                    }
                  </div>
                </div>
                <div className="relative flex-1 text-center">
                  <svg
                    width="156"
                    height="19"
                    viewBox="0 0 156 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-primary"
                  >
                    <circle
                      cx="9"
                      cy="10"
                      r="9"
                      fill="currentColor"
                      fill-opacity="0.1"
                    />
                    <circle
                      cx="9.0001"
                      cy="10"
                      r="6.42857"
                      fill="currentColor"
                      fill-opacity="0.25"
                    />
                    <circle
                      cx="8.99997"
                      cy="10"
                      r="3.85714"
                      fill="currentColor"
                    />
                    <circle
                      cx="147"
                      cy="10"
                      r="9"
                      fill="currentColor"
                      fill-opacity="0.1"
                    />
                    <circle
                      cx="147"
                      cy="10"
                      r="6.42857"
                      fill="currentColor"
                      fill-opacity="0.25"
                    />
                    <circle cx="147" cy="10" r="3.85714" fill="currentColor" />
                    <line
                      x1="22.5"
                      y1="9.5"
                      x2="66.5"
                      y2="9.5"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-dasharray="5 3"
                    />
                    <line
                      x1="89.5"
                      y1="9.5"
                      x2="133.5"
                      y2="9.5"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-dasharray="5 3"
                    />
                    <path
                      d="M87 9.4C87 10.12 86.37 10.75 85.65 10.75H80.7L76.2 17.95H74.4L76.65 10.75H71.7L70.35 12.55H69L69.9 9.4L69 6.25H70.35L71.7 8.05H76.65L74.4 0.850004H76.2L80.7 8.05H85.65C86.37 8.05 87 8.68 87 9.4Z"
                      fill="currentColor"
                    />
                  </svg>

                  <div className="text-[12px] text-secondary absolute left-1/2 transform -translate-x-1/2">
                    {" "}
                    {calculateTimeDifference(
                      chooseFlight[0]?.options?.[0]?.flights?.[0]?.startdate,
                      chooseFlight[0]?.options?.[0]?.flights?.[0]?.enddate
                    )}
                  </div>
                </div>
                <div
                  className="flex flex-col gap-1 items-end"
                  style={{ width: "90px" }}
                >
                  <div className="text-secondary font-semibold text-[20px] text-right">
                    {chooseFlight[0]?.options?.[0]?.flights?.[0]?.endpoint}
                  </div>
                  <div className="text-[#808991] font-medium text-[11px]">
                    {
                      airports?.find(
                        (item) =>
                          item.code ===
                          chooseFlight[0].options?.[0]?.flights?.[0]?.endpoint
                      )?.namevn
                    }
                  </div>
                </div>
              </div>
              <div className="flex w-full justify-between items-center mb-2">
                <div
                  className="flex flex-col gap-1 items-start"
                  style={{ width: "90px" }}
                >
                  <div className="text-secondary font-semibold text-[16px]">
                    {formatTime(
                      chooseFlight[0]?.options?.[0]?.flights?.[0]?.startdate
                    )}
                  </div>
                  <div className="text-[#808991] font-medium text-[11px]">
                    {formatDateNoTime(
                      chooseFlight[0]?.options?.[0]?.flights?.[0]?.startdate
                    )}
                  </div>
                </div>
                <div
                  className="flex flex-col gap-1 items-end"
                  style={{ width: "90px" }}
                >
                  <div className="text-secondary font-semibold text-[16px]">
                    {formatTime(
                      chooseFlight[0]?.options?.[0]?.flights?.[0]?.enddate
                    )}
                  </div>
                  <div className="text-[#808991] font-medium text-[11px]">
                    {formatDateNoTime(
                      chooseFlight[0]?.options?.[0]?.flights?.[0]?.enddate
                    )}
                  </div>
                </div>
              </div>
              <img
                src={`${process.env.REACT_APP_BASE_URL}/${chooseFlight[0]?.airline?.iconurl}`}
                alt=""
                className="w-[60px] h-[30px]"
              />
            </div>
            {chooseFlight.length === 2 && (
              <>
                <hr
                  className="my-4"
                  style={{ borderTopWidth: "1px", borderStyle: "dashed" }}
                />
                <div className="mb-3">
                  <div className="flex w-full justify-between items-center mb-4">
                    <div
                      className="flex flex-col gap-1 items-start"
                      style={{ width: "90px" }}
                    >
                      <div className="text-secondary font-semibold text-[20px]">
                        {
                          chooseFlight[1]?.options?.[0]?.flights?.[0]
                            ?.startpoint
                        }
                      </div>
                      <div className="text-[#808991] font-medium text-[11px]">
                        {
                          airports?.find(
                            (item) =>
                              item.code ===
                              chooseFlight[1].options?.[0]?.flights?.[0]
                                ?.startpoint
                          )?.name
                        }{" "}
                      </div>
                    </div>
                    <div className="relative flex-1 text-center">
                      <svg
                        width="156"
                        height="19"
                        viewBox="0 0 156 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="text-primary"
                      >
                        <circle
                          cx="9"
                          cy="10"
                          r="9"
                          fill="currentColor"
                          fill-opacity="0.1"
                        />
                        <circle
                          cx="9.0001"
                          cy="10"
                          r="6.42857"
                          fill="currentColor"
                          fill-opacity="0.25"
                        />
                        <circle
                          cx="8.99997"
                          cy="10"
                          r="3.85714"
                          fill="currentColor"
                        />
                        <circle
                          cx="147"
                          cy="10"
                          r="9"
                          fill="currentColor"
                          fill-opacity="0.1"
                        />
                        <circle
                          cx="147"
                          cy="10"
                          r="6.42857"
                          fill="currentColor"
                          fill-opacity="0.25"
                        />
                        <circle
                          cx="147"
                          cy="10"
                          r="3.85714"
                          fill="currentColor"
                        />
                        <line
                          x1="22.5"
                          y1="9.5"
                          x2="66.5"
                          y2="9.5"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-dasharray="5 3"
                        />
                        <line
                          x1="89.5"
                          y1="9.5"
                          x2="133.5"
                          y2="9.5"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-dasharray="5 3"
                        />
                        <path
                          d="M87 9.4C87 10.12 86.37 10.75 85.65 10.75H80.7L76.2 17.95H74.4L76.65 10.75H71.7L70.35 12.55H69L69.9 9.4L69 6.25H70.35L71.7 8.05H76.65L74.4 0.850004H76.2L80.7 8.05H85.65C86.37 8.05 87 8.68 87 9.4Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div className="text-[12px] text-secondary absolute left-1/2 transform -translate-x-1/2">
                        {" "}
                        {calculateTimeDifference(
                          chooseFlight[1]?.options?.[0]?.flights?.[0]
                            ?.startdate,
                          chooseFlight[1]?.options?.[0]?.flights?.[0]?.enddate
                        )}
                      </div>
                    </div>
                    <div
                      className="flex flex-col gap-1 items-end"
                      style={{ width: "90px" }}
                    >
                      <div className="text-secondary font-semibold text-[20px] text-right">
                        {chooseFlight[1].options?.[0]?.flights?.[0]?.endpoint}
                      </div>
                      <div className="text-[#808991] font-medium text-[11px]">
                        {
                          airports?.find(
                            (item) =>
                              item.code ===
                              chooseFlight[1].options?.[0]?.flights?.[0]
                                ?.endpoint
                          )?.name
                        }{" "}
                      </div>
                    </div>
                  </div>
                  <div className="flex w-full justify-between items-center mb-2">
                    <div
                      className="flex flex-col gap-1 items-start"
                      style={{ width: "90px" }}
                    >
                      <div className="text-secondary font-semibold text-[16px]">
                        {formatTime(
                          chooseFlight[1]?.options?.[0]?.flights?.[0]?.startdate
                        )}
                      </div>
                      <div className="text-[#808991] font-medium text-[11px]">
                        {formatDateNoTime(
                          chooseFlight[1]?.options?.[0]?.flights?.[0]?.startdate
                        )}
                      </div>
                    </div>
                    <div
                      className="flex flex-col gap-1 items-end"
                      style={{ width: "90px" }}
                    >
                      <div className="text-secondary font-semibold text-[16px]">
                        {formatTime(
                          chooseFlight[1]?.options?.[0]?.flights?.[0]?.enddate
                        )}
                      </div>
                      <div className="text-[#808991] font-medium text-[11px]">
                        {formatDateNoTime(
                          chooseFlight[1]?.options?.[0]?.flights?.[0]?.enddate
                        )}
                      </div>
                    </div>
                  </div>
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}/${chooseFlight[1]?.airline?.iconurl}`}
                    alt=""
                    className="w-[60px] h-[30px]"
                  />
                </div>
              </>
            )}
            <hr
              className="my-4"
              style={{ borderTopWidth: "1px", borderStyle: "dashed" }}
            />
            <ul className="list-none py-4">
              {chooseFlight[0].adt > 0 && (
                <li className="flex justify-between mb-2">
                  <span>{chooseFlight[0].adt} người lớn</span>
                  <span>
                    {_.sum(
                      _.map(chooseFlight, (f) => f.priceadt)
                    )?.toLocaleString("vi-VN")}{" "}
                    ₫
                  </span>
                </li>
              )}
              {chooseFlight[0].chd > 0 && (
                <li className="flex justify-between mb-2">
                  <span>{chooseFlight[0].chd} trẻ em</span>
                  <span>
                    {_.sum(
                      _.map(chooseFlight, (f) => f.pricechd)
                    )?.toLocaleString("vi-VN")}{" "}
                    ₫
                  </span>
                </li>
              )}
              {chooseFlight[0].inf > 0 && (
                <li className="flex justify-between mb-2">
                  <span>{chooseFlight[0].inf} em bé</span>
                  <span>
                    {_.sum(
                      _.map(chooseFlight, (f) => f.priceinf)
                    )?.toLocaleString("vi-VN")}{" "}
                    ₫
                  </span>
                </li>
              )}
              {bookingInfo.totalListPrice.totaltax > 0 && (
                <li className="flex justify-between mb-2">
                  <span>Thuế</span>
                  <span>
                    {bookingInfo.totalListPrice?.totaltax?.toLocaleString(
                      "vi-VN"
                    )}{" "}
                    ₫
                  </span>
                </li>
              )}
              {baggage > 0 && (
                <li className="flex justify-between mb-2">
                  <span>Hành lý</span>
                  <span>{baggage?.toLocaleString("vi-VN")} ₫</span>
                </li>
              )}
              {bookingInfo.voucherValue > 0 && (
                <li className="flex justify-between mb-2">
                  <span>Giảm giá</span>
                  <span className="text-[#00AB56]">
                    -{bookingInfo?.voucherValue?.toLocaleString("vi-VN")} ₫
                  </span>
                </li>
              )}
              <li className="flex justify-between">
                <span className="font-bold">
                  Tổng số tiền <br />
                  (đã bao gồm thuế phí)
                </span>
                <Tag className="text-[14px] font-semibold rounded-[20px] px-2 py-1 mr-0 bg-primary text-white">
                  {bookingInfo?.totalListPrice?.totalDisplay?.toLocaleString(
                    "vi-VN"
                  )}{" "}
                  ₫
                </Tag>
              </li>
            </ul>
          </div>
          <Button
            onClick={handlePayment}
            type="primary"
            className="w-[208px] h-[45px] rounded-[10px] text-center mx-auto text-[15px]"
          >
            <span className="font-semibold">Thanh toán</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Step4;
